function stringify(query: Record<string, string>): string {
    const qsArr = Object.keys(query).map(k => {
        return `${k}=${encodeURIComponent(query[k])}`
    })

    return qsArr.join("&")
}

export { stringify }
